import React from "react";
import { Nav, INavLink } from "@fluentui/react/lib/Nav";
import { ThemeProvider } from "@fluentui/react/lib/Theme";
import { darkBlueTheme, AppGlobals } from "./AppGlobals";

interface Props {
  onCloseMenu?: () => void;
}

export const CustomSignInMenu: React.FC<Props> = ({ onCloseMenu }) => {
  const imagesRoot: string = process.env.REACT_APP_ZedXImagesRoot!;

  // Read customer from URL
  const urlParams = new URLSearchParams(window.location.search);
  const clientParam = urlParams.get("c") || "";

  const isTraining = clientParam.startsWith("_");
  const customerRef = clientParam.replace(/^_/, "");

  // Detect demo mode
  const isDemo = !!AppGlobals.DemoUserEmail;

  // Title logic
  let accountTitle = "Live Account";

  if (isDemo) {
    accountTitle = "Demo Account";
  } else if (isTraining) {
    accountTitle = "Training Account";
  }

  const navLinks: INavLink[] = [
    {
      name: "Change Account",
      key: "change-account",
      url: process.env.REACT_APP_ZedX_Net!,
      iconProps: { iconName: "Back" }
    }
  ];

  return (
    <ThemeProvider theme={darkBlueTheme}>
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>

        {/* LOGO */}
        <div
          style={{
            width: "100%",
            paddingBottom: "10px",
            paddingLeft: "15px",
            display: "flex",
            alignItems: "center"
          }}
        >
          <img
            src={`${imagesRoot}/leftnav/LeftMenu-ZedXMainMenu.png`}
            alt="ZedX"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>

        {/* ACCOUNT BOX */}
        <div
          style={{
            backgroundColor: "#1A619F",
            color: "white",
            padding: "10px 15px",
            margin: "5px 10px 10px",
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            gap: "2px"
          }}
        >
          <div>{accountTitle}</div>
          <div>{customerRef}</div>
        </div>

        {/* MENU (hidden for demo) */}
        {!isDemo && (
          <Nav
            groups={[{ links: navLinks }]}
            onLinkClick={() => {
              if (onCloseMenu) onCloseMenu();
            }}
          />
        )}
      </div>
    </ThemeProvider>
  );
};